function Other2(props)
{
    return(
        <svg className={props.class} style={{...props.style}} viewBox="0 0 480 480"><path d="M320 240 160 0 0 240h160l160 240 160-240H320z"></path></svg>
    )
}

export default Other2